import { PageModule, HomepageHeader, HomepageFooter, EventNavbar, PageModuleType, Dictionary } from "../types/working-model";

export function hasPageModuleControls(_module: PageModule | HomepageHeader | HomepageFooter | EventNavbar): _module is PageModule {
	// check to see if module has key that only lives on PageModule types
	return (_module as PageModule)?.content_modules !== undefined;
}

export function hasFooterControls(_module: PageModule | HomepageHeader | HomepageFooter | PageModuleType | EventNavbar): _module is HomepageFooter {
	// if _module has a callToAction then this will fail
	// and we know its not a footer
	const isNotHeader = !hasHeaderControls(_module);
	return isNotHeader && (_module as HomepageFooter)?.logo !== undefined;
}

export function hasHeaderControls(_module: PageModule | HomepageHeader | HomepageFooter | PageModuleType | EventNavbar): _module is HomepageHeader {
	return (_module as HomepageHeader)?.callToAction !== undefined;
}

export function hasNavbarControls(_module: PageModule | HomepageHeader | HomepageFooter | PageModuleType | EventNavbar): _module is EventNavbar {
	return (_module as EventNavbar)?.navbarItems !== undefined;
}

type BackgroundStylingOverrides = NonNullable<NonNullable<EventNavbar['styling_overrides']>['background']>;

export function makeBackgroundStylingOverrides(
	_module: PageModule | HomepageHeader | HomepageFooter | EventNavbar,
	colorKey: string
): BackgroundStylingOverrides {
	const isColor = !colorKey.includes('.');
	const isRestoringDefault = colorKey === "";

	//If we are restoring default we want it to just be a blank string, if changing color we want the classname with appended"-background"
	if (isColor && !isRestoringDefault) {
		colorKey += "-background";
	}
	return {
		color: _module?.styling_overrides?.background?.color ?? '',
		image: { is_on: false, src: _module?.styling_overrides?.background?.image.src ?? '' },
		[isColor ? 'color' : 'image']: isColor ? colorKey : { is_on: true, src: colorKey }
	};
}

export function hasProvidedControls<T>(object: Dictionary, key: keyof T): boolean {
	return (object as T)?.[key] !== undefined;
}
